

export function triggerActionEvent(el) {
	const event = new CustomEvent('action', {
		bubbles: true,
		cancelable: true
	});
	el.dispatchEvent(event);
}
